module.exports = __webpack_public_path__ + "static/media/Artboard15.6388c682.png";